import { Star, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const GOOGLE_REVIEW_URL = "https://www.google.com/search?q=real+life+learners+driving+school+sunshine+coast";

const steps = [
  ["01", "Finished a lesson or passed your test?"],
  ["02", "Tap the gold button below"],
  ["03", "Tell the next nervous driver how it felt"],
];

export default function GoogleReview() {
  return (
    <section id="leave-review" className="px-6 md:px-12 py-24 md:py-32 max-w-[1600px] mx-auto">
      <div className="border border-white/15 bg-[#111113] p-10 md:p-16 relative overflow-hidden">
        <div className="absolute -top-10 -right-10 w-40 h-40 border-2 border-[#F5B301] rotate-12 pointer-events-none" />
        <div className="grid lg:grid-cols-[1.3fr_1fr] gap-12 items-center">
          <Reveal>
            <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#F5B301] mb-6">Review Us</p>
            <h2 className="font-cabinet font-black uppercase tracking-tighter text-4xl md:text-6xl leading-[0.95] text-[#f5f5f0]">
              Passed with us? <span className="text-[#F5B301]">Tell the world.</span>
            </h2>
            <p className="font-script text-2xl md:text-3xl text-white/60 mt-6 -rotate-1">
              Your words help the next nervous driver take the first step.
            </p>
            <div className="flex items-center gap-2 mt-8" data-testid="google-review-stars">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-7 h-7 text-[#F5B301] fill-[#F5B301]" />
              ))}
            </div>
            <a
              href={GOOGLE_REVIEW_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="google-review-button"
              className="group inline-flex items-center gap-3 bg-[#F5B301] text-[#0a0a0a] font-bold uppercase tracking-wide text-sm px-10 py-5 mt-10 hover:bg-[#f5f5f0] transition-colors duration-300"
            >
              Leave a Google Review
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
          </Reveal>

          <Reveal delay={0.15}>
            <ol className="space-y-8">
              {steps.map(([num, text]) => (
                <li key={num} className="flex items-center gap-6 border-b border-white/10 pb-8 last:border-b-0 last:pb-0">
                  <span className="font-cabinet font-black text-5xl text-outline-gold leading-none shrink-0">{num}</span>
                  <p className="text-base md:text-lg font-semibold text-[#f5f5f0]">{text}</p>
                </li>
              ))}
            </ol>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
